import React, { useEffect, useState } from "react";
import "./ViewNotification.css";
import Close from "../../assets/Modal-Close-Icon.svg";
import Download from "../../assets/download.svg";
import RejectSection from "./RejectNotify/RejectSection";
import {
  API_Notification,
  DraftToSubmit,
  GetAllNotification_M3,
  PublishNotification,
} from "../../../../api/notifyapi/Notifyapi";
import dayjs, { Dayjs } from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../redux-store/store";

import { Tooltip } from "antd";
import {
  IFilterModel,
  NotificationActions,
} from "../../../../slices/NotificationSlice";
import { ETableRowActionFieldApplicable } from "../../notificationPage/NotificationMangement";
import { LEVEL_CONSTANT } from "../CreateAndEditNotify/FormDataConstants";
import ExpirayDateComponent from "./publishWithDateEdit/PublishDateEditComponent";
import { NotifyEffExpDate } from "./components/NotifyEffExpDate";
import Loader from "../../loader/Loader";
import {
  getPublishBtnTooltip,
  getRejectBtnTooltip,
  getSubmitButtonTooltip,
} from "../../TooltipContent/tooltipMessageHelper";

interface FileItem {
  fileName: string;
  copiedPath: string;
  uploadTime: string;
}
interface ViewNotificationProps {
  img?: any;
}

enum ViewNotificationModalTypes {
  None = "None",
  InfoView = "InfoView",
  RejectView = "RejectView",
  PublishExpiryView = "PublishExpiryView",
}

const ViewNotification: React.FC<ViewNotificationProps> = () => {
  const { user, features, switchRole } = useSelector(
    (state: RootState) => state.user
  );
  const data = useSelector((state: RootState) => state.notification.editData);
  const apiQuery = useSelector(
    (state: RootState) => state.notification.searchFilter.apiQuery
  );
  const searchFilter = useSelector(
    (state: RootState) => state.notification.searchFilter
  );
  const [modalType, setModalType] = useState<ViewNotificationModalTypes>(
    ViewNotificationModalTypes.InfoView
  );

  const dispatch = useDispatch<AppDispatch>();
  const [isExpired, setIsExpired] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isExpDateValid, setExpDateValid] = useState<boolean>(false);

  useEffect(() => {
    determineExpiryDate();
  }, [data]);

  const handleRejectSection = (): void => {
    setModalType(ViewNotificationModalTypes.RejectView);
  };

  const handleCloseExpiryDateComponent = (): void => {
    setModalType(ViewNotificationModalTypes.InfoView);
  };
  const handleCloseRejectSecton = (): void => {
    setModalType(ViewNotificationModalTypes.InfoView);
  };
  const closeviewPopup = (): void => {
    dispatch(NotificationActions.UpdateViewPopup(false));
  };

  const handleToSubmit = (id: string): void => {
    try {
      setIsLoading(true);
      if (data) {
        dispatch(
          DraftToSubmit({
            notificationIDs: [id],
            performedBy: data.createdBy.name,
          })
        ).then(() => {
          setIsLoading(false);
          dispatch(NotificationActions.UpdateViewPopup(false));
          if (searchFilter.globalSearch.value) {
            let lQuery: IFilterModel = {
              filters: searchFilter.globalSearchApiQuery.filters,
              isAscending: false,
              currentPageSize: searchFilter.apiQuery.currentPageSize,
              pageSize: searchFilter.apiQuery.pageSize,
              page: 1, //First time always get page 1
              isOr: true,
              isPageChanged: "",
              sortField: "",
            };

            dispatch(GetAllNotification_M3(lQuery));
          } else {
            dispatch(GetAllNotification_M3(searchFilter.apiQuery));
          }
        });
      }
    } catch (error) {}
  };

  const handleToPublish = () => {
    try {
      if (isExpired) {
        setModalType(ViewNotificationModalTypes.PublishExpiryView);
      } else if (data) {
        setIsLoading(true);
        dispatch(
          PublishNotification({
            effectiveDate: data.effectiveDate,
            expiryDate: data.expiryDate,
            notificationIDs: [data.notificationID],
            performedBy: data.assignedUser[0],
            state: "PUBLISHED",
          })
        ).then(() => {
          setIsLoading(false);
          dispatch(NotificationActions.UpdateViewPopup(false));
          if (searchFilter.globalSearch.value) {
            let lQuery: IFilterModel = {
              filters: searchFilter.globalSearchApiQuery.filters,
              isAscending: false,
              currentPageSize: searchFilter.apiQuery.currentPageSize,
              pageSize: searchFilter.apiQuery.pageSize,
              page: 1, //First time always get page 1
              isOr: true,
              isPageChanged: "",
              sortField: "",
            };

            dispatch(GetAllNotification_M3(lQuery));
          } else {
            dispatch(GetAllNotification_M3(searchFilter.apiQuery));
          }
        });
      }
    } catch (error) {
      // Handle error appropriately
      setIsLoading(false);
    }
  };

  // render style for status
  const renderStatusStyle = () => {
    let className = "view-modal-status-span-element";

    if (data?.status === "WAITING_SENT_FOR_PUBLICATION") {
      className += " waiting";
    } else if (data?.status === "PUBLISHED") {
      className += " published";
    } else if (data?.status === "RECALL") {
      className += " recall";
    } else if (data?.status === "SUBMITTED") {
      className += " submitted";
    }

    return className;
  };

  // set the tooltip for submit button
  // const getSubmitButtonTooltip = () => {
  //   if (data?.status !== "DRAFT") {
  //     return "Cannot submit because the status is not DRAFT.";
  //   }
  //   // if (isExpired) {
  //   //   return "Cannot submit because the date is expired.";
  //   // }
  //   if (user?.email !== data.createdBy.name) {
  //     return "Only created User Can submit the Notification";
  //   }

  //   if (isSubmitButtonState() == ETableRowActionFieldApplicable.Blur) {
  //     return "Submit action can't be performed";
  //   }
  //   return "Click to submit.";
  // };
const downloadZipFile = async (notificationId: string): Promise<void> => {
    try {
        await API_Notification.DownloadZipFile(notificationId);
    } catch (error) {
        console.error("Error downloading zip:", error);
    }
};
  // submit button condition based on user role and level
  const isSubmitButtonState = (): ETableRowActionFieldApplicable => {
    if (!data && !user) {
      return ETableRowActionFieldApplicable.Blur;
    }

    // if (isExpired){
    //   return ETableRowActionFieldApplicable.Blur
    // }

    //Admin role submit both level 1 and leve2 && createduser same
    if (
      data?.level === LEVEL_CONSTANT.level1 &&
      features.notification.submitNotify.level1 &&
      data.createdBy.name === user?.email
    ) {
      return ETableRowActionFieldApplicable.Show;
    } else if (
      data?.level === LEVEL_CONSTANT.level2 &&
      features.notification.submitNotify.level2 &&
      data.createdBy.name === user?.email
    ) {
      return ETableRowActionFieldApplicable.Show;
    }
    return ETableRowActionFieldApplicable.Blur;
  };

  const getPublishRejectBtnState = (): ETableRowActionFieldApplicable => {
    //notification should be in expired
    //notification assigned user should be the loggedin user
    //logged user should have the notification level type publish access

    if (!user && !data) {
      return ETableRowActionFieldApplicable.Blur;
    }

    if (isExpired && data?.level === LEVEL_CONSTANT.level1) {
      return ETableRowActionFieldApplicable.Blur;
    }

    if (
      user?.email?.toLocaleLowerCase() !==
      data?.assignedUser.toString().toLocaleLowerCase()
    ) {
      return ETableRowActionFieldApplicable.Blur;
    }

    if (
      data?.level === LEVEL_CONSTANT.level1 &&
      features.notification.publishNotify.level1 &&
      data.assignedUser.toString() === user?.email
    ) {
      return ETableRowActionFieldApplicable.Show;
    } else if (
      data?.level === LEVEL_CONSTANT.level2 &&
      features.notification.publishNotify.level2 &&
      data.assignedUser.toString() === user?.email
    ) {
      return ETableRowActionFieldApplicable.Show;
    }

    return ETableRowActionFieldApplicable.Blur;
  };

  // Footer button render
  const renderFooterButtons = (id: string) => {
    let status = data?.status;

    switch (status) {
      case "DRAFT":
        return (
          <>
            <Tooltip
              title={() => getSubmitButtonTooltip(data, user, switchRole)}
            >
              <button
                disabled={
                  isSubmitButtonState() === ETableRowActionFieldApplicable.Blur
                    ? true
                    : false
                }
                className={`popup-create-btn ${
                  isSubmitButtonState() === ETableRowActionFieldApplicable.Blur
                    ? " disabled-button-style"
                    : ""
                }`}
                onClick={() => {
                  if (
                    isSubmitButtonState() ===
                    ETableRowActionFieldApplicable.Show
                  ) {
                    handleToSubmit(id);
                  }
                }}
              >
                Submit
                {isLoading ? <Loader /> : <></>}
              </button>
            </Tooltip>

            <button
              className="popup-Cancel-btn"
              onClick={() => closeviewPopup()}
            >
              cancel
            </button>
          </>
        );
      case "WAITING_SENT_FOR_PUBLICATION":
        return (
          <>
            <Tooltip
              title={() =>
                getPublishBtnTooltip(data, user, switchRole, isExpired)
              }
            >
              <button
                disabled={
                  getPublishRejectBtnState() ===
                  ETableRowActionFieldApplicable.Blur
                    ? true
                    : false
                }
                className={`popup-create-btn ${
                  getPublishRejectBtnState() ===
                  ETableRowActionFieldApplicable.Blur
                    ? " disabled-button-style"
                    : ""
                }`}
                onClick={() =>
                  getPublishRejectBtnState() ===
                  ETableRowActionFieldApplicable.Show
                    ? handleToPublish()
                    : ""
                }
              >
                Publish
                {isLoading ? <Loader /> : <></>}
              </button>
            </Tooltip>
            <Tooltip
              title={() =>
                getRejectBtnTooltip(data, user, switchRole, isExpired)
              }
            >
              <button
                disabled={
                  getPublishRejectBtnState() ===
                  ETableRowActionFieldApplicable.Blur
                    ? true
                    : false
                }
                className={`popup-create-btn outline-btn ${
                  getPublishRejectBtnState() ===
                  ETableRowActionFieldApplicable.Blur
                    ? " disabled-transparent-button-style"
                    : ""
                }`}
                onClick={() =>
                  getPublishRejectBtnState() ===
                  ETableRowActionFieldApplicable.Show
                    ? handleRejectSection()
                    : ""
                }
              >
                Reject
              </button>
            </Tooltip>
            <button
              className="popup-Cancel-btn"
              onClick={() => closeviewPopup()}
            >
              cancel
            </button>
          </>
        );
      default:
        break;
    }
  };

  // handle download file
  const downloadFile = async (notificationId: string, fileName: string): Promise<void> => {
    try {
        await API_Notification.DownloadFile(notificationId, fileName);
    } catch (error) {
        console.error("Error downloading file:", error);
    }
};
  const determineExpiryDate = () => {
    let lIsExpired = false;

    if (data?.expiryDate) {
      const currentDate = new Date();
      const expiration = new Date(data?.expiryDate);

      currentDate.setHours(0, 0, 0, 0);
      expiration.setHours(0, 0, 0, 0);
      lIsExpired = expiration < currentDate;
    }

    setIsExpired(lIsExpired);
  };

  const handleExpDateCheck = (valid: boolean) => {
    setExpDateValid(valid);
  };

  return (
    <div className="modal-overlay">
      <div className="view-modal-content">
        <div className="view-modal-header">
          <div className="view-header-subcontainer">
            <div className="popup-head">View Notification</div>
            <div className="view-header-pipebar"></div>
            <div className="view-modal-subHeading">{data?.nUniqueID}</div>
          </div>
          <div className="view-modal-status-element">
            Status: <span className={renderStatusStyle()}>{data?.status}</span>
          </div>
          <img
            src={Close}
            alt="close-icon"
            className="close-btn"
            tabIndex={0}
            onClick={() => closeviewPopup()}
          />
        </div>
        {modalType === ViewNotificationModalTypes.RejectView && (
          <RejectSection onClose={handleCloseRejectSecton} />
        )}

        {modalType === ViewNotificationModalTypes.InfoView && (
          <>
            <div className="view-modal-body">
              <div className="view-notification-heading-element">
                Notification Details
              </div>
              <div>
                <div className="view-modal-body-subcontainer">
                  <div className="view-modal-content-container">
                    <div>
                      <label className="label-element">Title</label>
                      <div className="view-modal-value-element description-element">
                        {data?.title}
                      </div>
                    </div>
                    <div>
                      <label className="label-element">Description</label>
                      <div className="description-element view-modal-value-element">
                        {data?.description}
                      </div>
                    </div>
                  </div>
                  <div className="view-modal-content-container">
                    <div>
                      <label className="label-element">Level</label>
                      <div className="view-modal-value-element">
                        {data?.level}
                      </div>
                    </div>
                    <div>
                      <label className="label-element">Category</label>
                      <div className="view-modal-value-element">
                        {data?.category}
                      </div>
                    </div>
                  </div>
                  <div className="view-modal-content-container">
                    <div>
                      <label className="label-element">Expiry Date</label>
                      {/* <ExpiryDateDisplay data={data?.expiryDate} /> */}
                      <NotifyEffExpDate
                        date={data ? data.expiryDate : ""}
                        displayEditOpt={false}
                        field="Expiry"
                        errorMessage=""
                        validStartDateToEdit={dayjs()}
                        onEditDated={(date) => {}}
                        isValidDate={isExpDateValid}
                        onValidCheck={handleExpDateCheck}
                      />
                    </div>
                    {data?.category === "TARGET" && (
                      <div>
                        <label className="label-element">Target</label>
                        <div>
                          <ul
                            style={{
                              listStyle: "none",
                              paddingLeft: "0",
                              fontSize: "14px",
                              marginBottom: "0px",
                            }}
                          >
                            {data?.target.map((item: string, index: number) => (
                              <li key={index} className="value-element">
                                {item}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="view-attachment-main-container">
                    <div className="attachment-heading-container">
                      <div className="label-element">Attachments</div>
                      <button
                        className="download-button"
                        onClick={() =>
                        data?.attachments.length !== 0 &&
                        downloadZipFile(data!.notificationID)    
}
                        disabled={
                          !data?.attachments || data.attachments.length === 0
                        }
                      >
                        Download all
                      </button>
                    </div>
                    <div className="attachment-list-container">
                      <div className="attachment-file-container">
                        {data ? (
                          data.attachments.length > 0 ? (
                            data.attachments.map(
                              (item: FileItem, index: number) => (
                                <div className="attachment-files" key={index}>
                                  <div className="file-info">
                                    <div className="view-modal-value-element">
                                      {item.fileName}
                                    </div>
                                  </div>
                                  <button
                                    className="download-button"
                                    onClick={() => downloadFile(data!.notificationID, item.fileName)}

                                    aria-label={`Download ${item.fileName}`}
                                  >
                                    <img
                                      src={Download}
                                      alt="Download icon"
                                      className="download-icon"
                                    />
                                  </button>
                                </div>
                              )
                            )
                          ) : (
                            <div className="view-modal-value-element">
                              No files attached
                            </div>
                          )
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="general-detail-main-container">
                  <div className="general-details-Heading">General Details</div>
                  <div className="general-details-list-container">
                    <div>
                      <label className="label-element">Created By</label>
                      <div className="view-modal-value-element">
                        {data?.createdBy.name}
                      </div>
                    </div>
                    <div>
                      <label className="label-element">Last Updated By</label>
                      {data?.updatedBy.name !== undefined ? (
                        <div className="view-modal-value-element">
                          {data.updatedBy.name}
                        </div>
                      ) : (
                        <div
                          className="view-modal-value-element"
                          style={{ textAlign: "center" }}
                        >
                          -
                        </div>
                      )}
                    </div>
                    <div>
                      <label className="label-element">Created On</label>
                      <div className="view-modal-value-element">
                        {" "}
                        {dayjs(data?.createdBy.dateTime).format(
                          "YYYY/MM/DD"
                        )}{" "}
                      </div>
                    </div>
                    <div>
                      <label className="label-element">Last Updated On</label>
                      {data?.updatedBy.dateTime !== "0001-01-01T00:00:00" ||
                      "" ? (
                        <div className="view-modal-value-element">
                          {dayjs(data?.updatedBy.dateTime).format("YYYY/MM/DD")}
                        </div>
                      ) : (
                        <div
                          className="view-modal-value-element"
                          style={{ textAlign: "center" }}
                        >
                          -
                        </div>
                      )}
                    </div>
                    <div>
                      <label className="label-element">Assigned User</label>
                      {data?.assignedUser !== undefined ? (
                        <div className="view-modal-value-element">
                          {data?.assignedUser.join(", ")}
                        </div>
                      ) : (
                        <div
                          className="view-modal-value-element"
                          style={{ textAlign: "center" }}
                        >
                          -
                        </div>
                      )}
                    </div>

                    <div>
                      <label className="label-element">Published On</label>
                      {data?.status === "PUBLISHED" ||
                      data?.status === "RECALL" ? (
                        <div className="view-modal-value-element">
                          {dayjs(data?.publishedOn).format("YYYY/MM/DD")}
                        </div>
                      ) : (
                        <div
                          className="view-modal-value-element"
                          style={{ textAlign: "center" }}
                        >
                          -
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="view-modal-footer">
              {renderFooterButtons(data ? data.notificationID : "")}
            </div>
          </>
        )}
        {modalType === ViewNotificationModalTypes.PublishExpiryView && (
          <ExpirayDateComponent
            data={data}
            renderStatusStyle={renderStatusStyle}
            onClose={handleCloseExpiryDateComponent}
            onCloseViewPopup={closeviewPopup}
            checkExpiry={determineExpiryDate}
          />
        )}
      </div>
    </div>
  );
};

export default ViewNotification;
